module.exports = __webpack_public_path__ + "img/Other Skills.70b9d26e.png";